// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a0416b68","453":"b66d3113"}[chunkId] + ".chunk.js";
};